import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ChipInput from "material-ui-chip-input";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import TextField from "@material-ui/core/TextField";
// import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
// import FormControl from "@material-ui/core/FormControl";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import IconButton from "@material-ui/core/IconButton";
import RefreshIcon from "@material-ui/icons/Refresh";
import ClearIcon from "@material-ui/icons/Clear";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Tabs, Tab, Menu, Icon } from "@material-ui/core";
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@mui/material/Select'; //'@material-ui/core/Select';
import Tooltip from '@mui/material/Tooltip';
import CheckIcon from '@mui/icons-material/Check';
// import OutlinedInput from '@material-ui/core/OutlinedInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import StarIcon from '@mui/icons-material/Star';
import FlagIcon from '@mui/icons-material/Flag';

import {
  createCourse,
  fetchCourses,
  generateCourseCode,
  createDriveFolder,
  findDriveFolder,
  changeDriveFolder,
  shareFolder,
  addCourseDriveFolder,
  getScreenshotDevices,
  setScreenshotDevices,
  convertUnixToDate,
  updateCourseAdminSettings,
  convertToTAType,
  checkRemovedTAs,
  clearStudentRoster,
  reenrollStudents,
} from "../firebaseApi";
import { changeCourses } from "../redux";
// import Typography from "@material-ui/core/Typography";
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { v4 as uuidv4 } from "uuid";
import InstructorCourseSettingsDialogs from "./InstructorCourseSettingsDialogs";

const styles = (theme) => ({
  titleBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // justifyContent: "space-between",
    // alignItems: "baseline",
  },
  courseCode: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
  },
  toggles: { display: "flex", flexDirection: "column", alignItems: "start" },
  "MuiFormControlLabel-labelPlacementStart": {
    margin: 0,
  },
  generateButton: {
    marginX: "12px",
  },
  clearButton: {
    marginLeft: "12px",
  },
  addDeviceButton: {
    marginTop: "5px",
    marginLeft: "3px",
  },
  removeDeviceButton: {
    marginTop: "5px",
  },
});

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const privileges = [
  "Change Course Code",
  "Delete Polls",
  "Delete Sessions",
  "Edit Categories",
  "Edit Course Options",
  "Edit Enrollment",
  "Export Votes",
  "Open Lockout Polls",
  "View Enrollment",
  "Take Screenshots if Feature Enabled",
];

const defaultPrivileges = [
  "Delete Polls",
  "Delete Sessions",
  "Edit Enrollment",
  "Export Votes",
  "Open Lockout Polls",
  "View Enrollment",
];

class InstructorCourseSettings extends React.Component {
  constructor(props) {
    super(props);

    if (!this.props.adminView) {
      getScreenshotDevices({email: this.props.account.accountEmail}).then((deviceOptions) => {
        this.setState({
          deviceOptions: deviceOptions,
          currDeviceName: Object.hasOwn(deviceOptions, deviceUUID) ? deviceOptions[deviceUUID] : "",
        });
      });
    }
    let deviceUUID = localStorage.getItem("deviceUUID");

    this.state = {
      courseInstructorID: this.props.course?.courseInstructorID ?? this.props.account.accountEmail,
      courseID: this.props.course?.courseID ?? "",
      name: this.props.course?.courseName ?? "",
      term: this.props.course?.courseTerm ?? "",
      courseCode: this.props.course?.courseCode ?? "",
      isActive: this.props.course?.isActive ?? true,
      iClickerEn: this.props.course?.iClickerEn ?? false,
      iClickerFreq: this.props.course?.iClickerFreq ?? "AA",
      anonVoteEn: this.props.course?.anonVoteEn ?? false,
      anonChooseCategories: this.props.course?.anonChooseCategories ?? (this.props.course?.chooseCategories ?? false),
      // forcePID: this.props.course?.forcePID ?? false,
      restrictDomain: this.props.course?.restrictDomain ?? false,
      restrictDomainEmail: this.props.course?.restrictDomainEmail ?? "",
      restrictDomainOverride: this.props.course?.restrictDomainOverride ?? "",
      geofencing: this.props.course?.geofencing ?? false,
      geoDistance: this.props.course?.geoDistance ?? 0.3,
      screenshotsEn: this.props.course?.screenshotsEn ?? false,
      screenshotDevice: this.props.course?.screenshotDevice === deviceUUID ?? false,
      chooseCategories: this.props.course?.chooseCategories ?? false,
      docLink: this.props.course?.docLink ?? "",
      studentPollHistory: this.props.course?.studentPollHistory ?? false,
      coInstructors: this.props.course?.coInstructors ?? [],
      coInstructorEnableScreenshots: this.props.course?.coInstructorEnableScreenshots ?? true,
      tas: this.props.course?.tas ?? [],
      taPrivileges: this.props.course?.taPrivileges ?? defaultPrivileges,
      categoryNames: this.props.course ? Object.keys(this.props.course.courseCategories) : [],
      optionNames: this.props.course
        ? Object.values(this.props.course.courseCategories).map((value) => value.slice())
        : [],
      includedSessions: this.props.course?.includedSessions ?? [],
      lockedPolls: this.props.course?.lockedPolls ?? false,
      // deviceOptions: this.props.course?.deviceOptions ?? {},
      deviceOptions: {},
      selectedDevice: this.props.course?.screenshotDevice ?? {},
      // currDeviceName: Object.hasOwn(this.props.course?.deviceOptions ?? {}, deviceUUID) ? this.props.course?.deviceOptions[deviceUUID] : "",
      currDeviceName: "",
      currDeviceUUID: deviceUUID,
      anonymousCourse: this.props.course?.anonymousCourse ?? false,

      //admin settings
      maxTAs: this.props.course?.maxTAs ?? 20,
      starred: this.props.course?.starred ?? false,
      markedForArchive: this.props.course?.markedForArchive ?? false,
      notifyArchive: this.props.course?.notifyArchive ?? false,

      // Dialogs
      loading: false,
      studentCategoriesDialog: false,
      // forcePIDDialog: false,
      restrictDomainDialog: false,
      anonVotingDialog: false,
      geofencingDialog: false,
      pollHistoryDialog: false,
      screenshotDialog: false,
      experimentalDialog: false,
      lockOutDialog: false,
      archiveCourseDialog: false,
      tab: 0,
    
      // Errors
      nameError: "",
      taError: false,
      termError: "",
      quarterError: "",
      courseCodeError: "",
      categoryNamesErrors: "",
      optionNamesErrors: this.props.course
        ? Object.keys(this.props.course.courseCategories).map(() => "")
        : [],
    };
    
  }
  /* uncomment out when finished with tutors
  <ChipInput
  fullWidth
  margin="normal"
  label="Tutors"
  placeholder="tutor@ucsd.edu"
  value={this.state.tutors}
  helperText="enter the email address associated with tutor account"
  onAdd={(tutors) => {
    this.setState((prevState) => ({
      tutors: [...prevState.tutors, tutors],
    }));
  }}
  onDelete={(deletedTutors, index) => {
    this.setState((prevState) => ({
      tutors: prevState.tutors.filter(
        (tutor) => tutor !== deletedTutors
      ),
    }));
  }}
/> */

  async refreshCourses () {
    let data = {
      accountID: this.props.account.accountID,
    };
    fetchCourses(data).then((courses) => {
      this.props.openRefreshDialog(true);
      this.props.openCtl(false);
      this.props.changeCourses(courses);
      this.props.history.push("/instructor/");
    });
  }
  
  render() {
    let mobile = this.props.width === "sm" || this.props.width === "xs";

    return (
      <>
      <Dialog
        disableEscapeKeyDown
        disableEnforceFocus
        fullScreen={mobile}
        fullWidth
        maxWidth="sm"
        open={this.props.open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            this.props.openCtl(false);
          }
        }}
      >
        <DialogTitle>
          <div className={this.props.classes.titleBar}>
            <div>{this.props.newCourse ? "Add Course" : "Course Settings"}</div>
            <div style={{ marginLeft: "auto" }}>
              {/* {this.props.adminView && 
                <FormControlLabel
                  // style={{marginRight: 5 }}
                  control={
                    <Switch
                      checked={!!this.state.markedForArchive}
                      color="primary"
                      onChange={(event) => {
                        this.setState({
                          markedForArchive: event.target.checked ? Date.now() : false,
                        });
                      }}
                      name="markForArchive"
                    />
                  }
                  label={"Mark For Archiving"}
                  labelPlacement="start"
                />
              } */}
              {this.props.selRole === "ta" ? null :
                <div style={{display: "flex", flexDirection: "row"}}>
                  <FormControlLabel
                    // style={{marginLeft: "auto"}}
                    control={
                      <Switch
                        checked={this.state.isActive}
                        color="primary"
                        onChange={(event) => {
                          this.setState({ "isActive": event.target.checked });
                        }}
                        name="active"
                      />
                    }
                    label="Active Course"
                    labelPlacement="start"
                  />
                  {(this.props.adminView  || this.state.markedForArchive) &&
                    <Tooltip 
                      placement="bottom"
                      title={this.props.adminView ? (!!this.state.markedForArchive ? "Unmark for Archiving" : "Mark for Archiving") : "This course has been marked for archiving"}
                    >
                      <IconButton
                        color={!!this.state.markedForArchive ? "primary" : "default"}
                        onClick={() => {
                          if (this.props.adminView) {
                            this.setState(
                              {
                                markedForArchive: !!this.state.markedForArchive ? false : Date.now(),
                                notifyArchive: !(!!this.state.markedForArchive),
                              }
                            );
                          }
                        }}
                      >
                        <FlagIcon />
                      </IconButton>
                    </Tooltip>
                  }
                  <IconButton
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      this.setState({ archiveCourseDialog: true });
                    }}
                  >
                    <InfoOutlinedIcon />
                  </IconButton>
                </div>
              }
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <Tabs
            value={this.state.tab}
            centered
            onChange={(event, newValue) => {
              this.setState({ tab: newValue });
            }}
          >
            <Tab label="General" />
            <Tab label="Options" />
            {this.props.adminView && <Tab label="Admin" />}
          </Tabs>

          {(this.state.tab === 1) && (
            <div className={this.props.classes.toggles}>
              {/*
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.iClickerEn}
                  color="primary"
                  onChange={(event) => {
                    this.setState({
                      iClickerEn: event.target.checked,
                    });
                  }}
                  name="iclicker"
                />
              }
              label="Enable iClicker"
              labelPlacement="start"
            />
            */}
              {/*
            <FormControlLabel
              disabled={!this.state.iClickerEn}
              control={
                <div style={{ marginLeft: "5px" }}>
                  <Select
                    disabled={!this.state.iClickerEn}
                    value={this.state.iClickerFreq[0]}
                    onChange={(event) => {
                      let freq =
                        event.target.value + this.state.iClickerFreq[1];
                      this.setState({
                        iClickerFreq: freq,
                      });
                    }}
                    name="frequency0"
                  >
                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                    <MenuItem value="C">C</MenuItem>
                    <MenuItem value="D">D</MenuItem>
                    <MenuItem value="E">E</MenuItem>
                  </Select>
                  <Select
                    disabled={!this.state.iClickerEn}
                    value={this.state.iClickerFreq[1]}
                    onChange={(event) => {
                      let freq =
                        this.state.iClickerFreq[0] + event.target.value;
                      this.setState({
                        iClickerFreq: freq,
                      });
                    }}
                    name="frequency1"
                  >
                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                    <MenuItem value="C">C</MenuItem>
                    <MenuItem value="D">D</MenuItem>
                    <MenuItem value="E">E</MenuItem>
                  </Select>
                </div>
              }
              label="iClicker Frequency"
              labelPlacement="start"
            />
            */}
              <Typography
                style={{ fontSize: "1.15rem", margin: "25px 0 10px 0" }}
              >
                Signup options:
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.chooseCategories}
                      color="primary"
                      disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                      onChange={(event) => {
                        this.setState({
                          chooseCategories: event.target.checked,
                        });
                      }}
                      name="studentcategories"
                    />
                  }
                  label="Force students to select category labels"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ studentCategoriesDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </div>
              {this.state.chooseCategories && (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <Typography 
                    style={{ 
                      marginLeft: 50, 
                      color: (this.props.selRole && !this.state.taPrivileges.includes("Edit Course Options"))
                       === "ta" ? "#A9A9A9" : "black" 
                    }}>
                      Doc Link:
                  </Typography>
                  <TextField
                    value={this.state.docLink}
                    disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                    margin="dense"
                    variant="outlined"
                    style={{
                      marginLeft: "5px",
                      width: "175px",
                    }}
                    onChange={(event) => {
                      this.setState({
                        docLink: event.target.value,
                      });
                    }}
                    inputProps={{
                      style: {
                        height: "35px",
                        padding: "0 14px",
                        fontSize: "14px",
                      },
                    }}
                  />
                </div>
              )}

              {/* <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.forcePID}
                      color="primary"
                      onChange={(event) => {
                        this.setState({
                          forcePID: event.target.checked,
                        });
                      }}
                      name="forcePID"
                    />
                  }
                  label="Force PID"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ forcePIDDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </div> */}

              <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.restrictDomain}
                      color="primary"
                      onChange={(event) => {
                        this.setState({
                          restrictDomain: event.target.checked,
                        });
                      }}
                      name="restrictDomain"
                    />
                  }
                  disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                  label="Restrict self-signup domain"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ restrictDomainDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </div>
              {this.state.restrictDomain && (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <Typography 
                    style={{ 
                      marginLeft: 50, 
                      color: (this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))) ? 
                        "#A9A9A9" : "black", 
                    }}
                  >
                    Email domain:
                  </Typography>
                  <TextField
                    value={this.state.restrictDomainEmail}
                    disabled={this.props.adminView || (this.props.selRole === "ta" && !this.props.courses?.taPrivileges?.includes("Edit Course Options"))}
                    margin="dense"
                    variant="outlined"
                    style={{
                      marginLeft: "5px",
                      width: "125px",
                    }}
                    onChange={(event) => {
                      this.setState({
                        restrictDomainEmail: event.target.value,
                      });
                    }}
                    inputProps={{
                      style: {
                        height: "35px",
                        padding: "0 14px",
                        fontSize: "14px",
                      },
                      placeholder: "ex: @ucsd.edu",
                    }}
                  />
                  <Typography 
                    style={{ marginLeft: 20, 
                    color: (this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))) ? 
                      "#A9A9A9" : "black",
                    }}
                  >
                    Override code:
                  </Typography>
                  <TextField
                    value={this.state.restrictDomainOverride}
                    disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                    margin="dense"
                    variant="outlined"
                    style={{
                      marginLeft: "5px",
                      width: "90px",
                    }}
                    onChange={(event) => {
                      this.setState({
                        restrictDomainOverride: event.target.value,
                      });
                    }}
                    inputProps={{
                      style: {
                        height: "35px",
                        padding: "0 14px",
                        fontSize: "14px",
                      },
                    }}
                  />
                </div>
              )}

              <Typography
                style={{ fontSize: "1.15rem", margin: "25px 0 10px 0" }}
              >
                Voting options:
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.anonVoteEn}
                      disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                      color="primary"
                      onChange={(event) => {
                        this.setState({
                          anonVoteEn: event.target.checked,
                          anonymousCourse: false,
                        });
                      }}
                      name="anonvote"
                    />
                  }
                  label="Enable anonymous users"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ anonVotingDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </div>
              {this.state.anonVoteEn && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    alignItems: "flex-start",
                    marginLeft: 50,
                  }}
                >
                  <FormControlLabel
                    style={{ marginBottom: 8, marginLeft: 0}}
                    control={
                      <Switch
                        checked={this.state.anonymousCourse}
                        color="primary"
                        disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                        onChange={(event) => {
                          this.setState({
                            anonymousCourse: event.target.checked,
                          });
                        }}
                        name="anonymouscourse"
                      />
                    }
                    label={<Typography>Restrict course enrollment to anonymous users only</Typography>}
                    labelPlacement="start"
                  />
                  <Typography>Shortcut:
                    <Typography component={"span"} display={"inline"} style={{ color: "#787b80" }}>
                      {" " + window.location.origin + "/anon/" + this.state.courseCode}
                    </Typography>  
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.anonChooseCategories}
                        color="primary"
                        onChange={(event) => {
                          this.setState({
                            anonChooseCategories: event.target.checked,
                          });
                        }}
                        name="screenshotDevice"
                        size="small"
                      />
                    }
                    disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                    label={<Typography style={{ fontSize: 13 }}>Force anonymous users to select category labels</Typography>}
                    style={{ marginLeft: 1 }}
                  />
                  {/* <TextField
                    value={window.location.origin + "/anon/" + this.state.courseCode}
                    margin="dense"
                    variant="outlined"
                    disabled
                    style={{
                      marginLeft: "5px", 
                      width: "175px",
                    }}
                  /> */}
                </div>
              )}
              <FormControl fullWidth>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.geofencing}
                        color="primary"
                        onChange={(event) => {
                          this.setState({
                            geofencing: event.target.checked,
                            experimentalDialog: event.target.checked,
                          });
                        }}
                        name="geofencing"
                      />
                    }
                    disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                    label="Enable geofencing"
                    labelPlacement="start"
                  />
                  {this.state.geofencing && (
                    <>
                      <TextField
                        value={this.state.geoDistance}
                        disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                        margin="dense"
                        variant="outlined"
                        style={{
                          marginLeft: "25px",
                        }}
                        onChange={(event) => {
                          this.setState({
                            geoDistance:
                              event.target.value === ""
                                ? ""
                                : Number(event.target.value),
                          });
                        }}
                        onBlur={() => {
                          if (this.state.geoDistance < 0) {
                            this.setState({ geoDistance: 0 });
                          } else if (this.state.geoDistance > 1000) {
                            this.setState({ geoDistance: 1000 });
                          }
                        }}
                        inputProps={{
                          step: 0.1,
                          min: 0,
                          max: 5,
                          type: "number",
                          "aria-labelledby": "geo-distance-slider",
                          style: {
                            height: "35px", // Adjust the height as needed
                            padding: "0 14px", // Adjust padding to fit the height
                            fontSize: "14px",
                          },
                        }}
                      />
                      <Typography 
                        style={{ 
                          marginLeft: "15px", 
                          color: (this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))) ? 
                            "#A9A9A9" : "black"  
                        }}>
                        kilometers
                      </Typography>
                    </>
                  )}
                  <IconButton
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      this.setState({ geofencingDialog: true });
                    }}
                  >
                    <InfoOutlinedIcon />
                  </IconButton>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.lockedPolls}
                      color="primary"
                      onChange={(event) => {
                        let newState = {lockedPolls: event.target.checked}

                        if (!event.target.checked && this.state.taPrivileges.includes("Open Lockout Polls")) {
                          let newPrivileges = this.state.taPrivileges;
                          newPrivileges.splice(newPrivileges.indexOf("Open Lockout Polls"), 1)
                          newState["taPrivileges"] = newPrivileges;
                        }
                        this.setState(newState);
                      }}
                      name="lockPoll"
                    />
                  }
                  disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                  label="Enable lockout polls"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ lockOutDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
                </div>
              </FormControl>

              <Typography
                style={{ fontSize: "1.15rem", margin: "25px 0 10px 0" }}
              >
                Management options:
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.studentPollHistory}
                      color="primary"
                      onChange={(event) => {
                        this.setState({
                          studentPollHistory: event.target.checked,
                        });
                      }}
                      name="pollhistory"
                    />
                  }
                  disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Course Options"))}
                  label="Enable student poll history"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ pollHistoryDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.screenshotsEn}
                      // Co-Instuctor has screenshot functionality disabled
                      // disabled={this.state.coInstructors.includes(
                      //   this.props.account.accountID
                      // )}
                      color="primary"
                      onChange={(event) => {
                        this.setState({
                          screenshotsEn: event.target.checked,
                          experimentalDialog: event.target.checked,
                          screenshotDevice: event.target.checked
                            ? this.state.screenshotDevice
                            : false,
                        });
                      }}
                      name="screenshots"
                    />
                  }
                  disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)}
                  label="Enable screenshots"
                  labelPlacement="start"
                />
                <IconButton
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    this.setState({ screenshotDialog: true });
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>
                <Tooltip 
                  placement="top"
                  style={{
                    marginleft: 0,
                  }}
                  title={(this.state.coInstructorEnableScreenshots && this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) ? "Screenshots are enabled for the course instructor, co-instructors, and TAs" : (this.state.taPrivileges.includes("Take Screenshots if Feature Enabled") ? "Screenshots are enabled for the course instructor and TAs" : (this.state.coInstructorEnableScreenshots ? "Screenshots are enabled for the course instructor and co-instructors" : "Screenshots are only enabled for the course instructor"))}
                >
                  <IconButton
                    variant="outlined"
                    color="primary"
                  >
                    <AccountCircleIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {(this.state.screenshotsEn && !this.props.adminView)
                /*&&
                // Co-Instuctor has screenshot functionality disabled
                !this.state.coInstructors.includes(
                  this.props.account.accountID
                )*/ && (
                  // <FormControlLabel
                  //   control={
                  //     <Checkbox
                  //       checked={this.state.screenshotDevice}
                  //       color="primary"
                  //       onChange={(event) => {
                  //         this.setState({
                  //           screenshotDevice: event.target.checked,
                  //         });
                  //       }}
                  //       name="screenshotDevice"
                  //     />
                  //   }
                  //   disabled={this.props.selRole === "ta"}
                  //   label="Take screenshots on this device"
                  //   labelPlacement="start"
                  //   style={{ marginLeft: 50 }}
                  // />
                  <div style={{ display: "flex", flexDirection: "column",  marginLeft: 50 }}>
                  <FormControl style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <Typography style={{ color: (this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)) ? "#A9A9A9" : "black", marginRight: 5, maxWidth: "fit-content", minWidth: "fit-content" }}>Screenshot device:</Typography>
                    <Select
                      displayEmpty
                      id="demo-simple-select"
                      value={this.state.selectedDevice[this.props.account.accountEmail] ?? ""}
                      style={{
                        width: "150px",
                        fontSize: 14,
                        height: 35,
                      }}
                      disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)}
                      onChange={(event)=>{
                        console.log(event.target.value);
                        this.setState({
                          selectedDevice: {
                            ...this.state.selectedDevice,
                            [this.props.account.accountEmail] : event.target.value,
                          }
                        });
                      }}
                    >
                      <MenuItem value="" key="default" disabled>
                        No Device
                      </MenuItem>
                      {Object.entries(this.state.deviceOptions).map(([deviceUUID, deviceName]) => {
                        return <MenuItem value={deviceUUID} key={deviceUUID}>{deviceName}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "start",
                    }}
                  >
                    <Typography style={{ color: (this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)) ? "#A9A9A9" : "black", marginTop: "15px" }}>This device's name:</Typography>
                    <TextField
                      variant="outlined"
                      value={this.state.currDeviceName}
                      margin="dense"
                      disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)}
                      helperText={this.state.deviceOptions.hasOwnProperty(this.state.currDeviceUUID) ? "" : "Device not added"}
                      style={{
                        marginLeft: "5px",
                        width: "150px",
                      }}
                      onChange={(event) => {
                        this.setState({
                          currDeviceName: event.target.value,
                        });
                      }}
                      inputProps={{
                        style: {
                          height: "35px",
                          padding: "0 14px",
                          fontSize: "14px",
                        },
                      }}
                    />
                    <Tooltip title={"Add device"}>
                      <IconButton
                        className={this.props.classes.addDeviceButton}
                        variant="outlined"
                        disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)}
                        onClick={() => {
                          let deviceUUID = this.state.currDeviceUUID;

                          if (!deviceUUID) {
                            deviceUUID = uuidv4();
                            localStorage.setItem("deviceUUID", deviceUUID);
                          }
                          this.setState({
                            currDeviceUUID: deviceUUID,
                            deviceOptions: {
                              ...this.state.deviceOptions,
                              [deviceUUID]: this.state.currDeviceName,
                            }
                          });
                        }}
                      >
                        <CheckIcon color={(this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)) ? "#A9A9A9" : "primary"} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Remove device">
                      <IconButton
                        className={this.props.classes.removeDeviceButton}
                        variant="outlined"
                        disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) || (this.state.coInstructors.includes(this.props.account.accountEmail) && !this.state.coInstructorEnableScreenshots)}
                        onClick={() => {
                          let selectedDevice = {...this.state.selectedDevice};
                          let deviceOptions = {...this.state.deviceOptions};

                          if (deviceOptions.hasOwnProperty(this.state.currDeviceUUID)) {
                            delete deviceOptions[this.state.currDeviceUUID];
                          }

                          if (selectedDevice[this.props.account.accountEmail] === this.state.currDeviceUUID) {
                            delete selectedDevice[this.props.account.accountEmail];
                          }

                          this.setState({
                            selectedDevice: selectedDevice,
                            currDeviceName: "",
                            deviceOptions: deviceOptions,
                          });
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  </div>
                )}

              {/* <InstructorCourseSettingsDialogs
                studentCategoriesDialog={this.state.studentCategoriesDialog}
                // forcePIDDialog={this.state.forcePIDDialog}
                restrictDomainDialog={this.state.restrictDomainDialog}
                anonVotingDialog={this.state.anonVotingDialog}
                geofencingDialog={this.state.geofencingDialog}
                pollHistoryDialog={this.state.pollHistoryDialog}
                screenshotDialog={this.state.screenshotDialog}
                archiveCourseDialog={this.state.archiveCourseDialog}
                closeStudentCategoriesDialog={() =>
                  this.setState({ studentCategoriesDialog: false })
                }
                // closeForcePIDDialog={() =>
                //   this.setState({ forcePIDDialog: false })
                // }
                closeRestrictDomainDialog={() => {
                  this.setState({ restrictDomainDialog: false });
                }}
                closeAnonVotingDialog={() =>
                  this.setState({ anonVotingDialog: false })
                }
                closeGeofencingDialog={() =>
                  this.setState({ geofencingDialog: false })
                }
                closePollHistoryDialog={() =>
                  this.setState({ pollHistoryDialog: false })
                }
                closeScreenshotDialog={() =>
                  this.setState({ screenshotDialog: false })
                }
                closeArchiveCourseDialog={() => 
                  this.setState({ archiveCourseDialog: false})
                }
              /> */}

              <Dialog
                open={this.state.experimentalDialog}
                onClose={() => {
                  this.setState({ experimentalDialog: false });
                }}
              >
                <DialogTitle>
                  <Typography style={{ fontSize: "1.3rem" }} color="primary">
                    Experimental Feature!
                  </Typography>
                </DialogTitle>
                <DialogContent>
                  <Typography>
                    This feature is currently under development. It may not be
                    fully stable. If this is an issue for your course, it is
                    recommended to disable this functionality.
                  </Typography>
                </DialogContent>
                <Button
                  onClick={() => {
                    this.setState({ experimentalDialog: false });
                  }}
                  color="primary"
                >
                  Close
                </Button>
              </Dialog>
              <Dialog
                open={this.state.lockOutDialog}
                onClose={() => {
                  this.setState({ lockOutDialog: false });
                }}
              >
                <DialogTitle>
                  <Typography style={{ fontSize: "1.3rem" }} color="primary">
                  What are lockout polls?
                  </Typography>
                </DialogTitle>
                <DialogContent>
                  <Typography>
                  An instructor can designate a poll as a lockout poll after the poll was started. 
                  Students who vote in a locked poll have an "L" prepended to their vote choice (e.g., "LB" for "B"). 
                  This feature is useful to discover students who are voting but are not in lecture. The instructor 
                  should explicitly notify the class to not vote before opening the lockout poll. Students who 
                  vote in a lockout poll are shown a message instructing them to see the instructor after class. 
                  Their votes will still be recorded. The instructor has the option to remove the "L" designation 
                  for students who voted accidentally in a lockout poll by using the "Lockout override" .
                  </Typography>
                </DialogContent>
                <Button
                  onClick={() => {
                    this.setState({ lockOutDialog: false });
                  }}
                  color="primary"
                >
                  Close
                </Button>
              </Dialog>
            </div>
          )}
          
          {(this.state.tab === 0) && (
            <>
              <TextField
                fullWidth
                margin="normal"
                label="Course Name"
                disabled={this.props.selRole === "ta" || this.props.adminView}
                value={this.state.name}
                error={this.state.nameError.length !== 0}
                helperText={this.state.nameError}
                onChange={(event) => {
                  this.setState({
                    name: event.target.value,
                    nameError: "",
                  });
                }}
              />
              {/* <TextField
                fullWidth
                margin="normal"
                label="Course Name"
                value={this.state.name}
                error={this.state.nameError.length !== 0}
                helperText={this.state.nameError}
                onChange={(event) => {
                  const input = event.target.value;
                  if (input.length <= 15) {
                    this.setState({
                      name: input,
                      nameError: "",
                    });
                  } else {
                    this.setState({
                      name: input.slice(0, 15),
                      nameError: "Course name cannot exceed 15 characters",
                    });
                  }
                }}
              /> */}

              <TextField
                fullWidth
                margin="normal"
                label="Course Term"
                disabled={this.props.selRole === "ta" || this.props.adminView}
                value={this.state.term}
                error={this.state.termError.length !== 0}
                helperText={
                  this.state.termError.length === 0
                    ? "eg. Fall 2020"
                    : this.state.termError
                }
                onChange={(event) => {
                  this.setState({
                    term: event.target.value,
                    termError: "",
                  });
                }}
              />

              <div className={this.props.classes.courseCode}>
                <TextField
                  fullWidth
                  disabled
                  margin="normal"
                  label="Course Code"
                  value={
                    this.state.courseCode === "" ? "" : this.state.courseCode
                  }
                  error={this.state.courseCodeError.length !== 0}
                  helperText={this.state.courseCodeError}
                />

                {this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Change Course Code")) ? null : <>
                  <IconButton
                    className={this.props.classes.generateButton}
                    variant="outlined"
                    onClick={() => {
                      generateCourseCode().then((newCode) => {
                        this.setState({
                          courseCode: newCode,
                          courseCodeError: "",
                        });
                      });
                    }}
                  >
                    <RefreshIcon />
                  </IconButton>

                  <IconButton
                    className={this.props.classes.clearButton}
                    variant="outlined"
                    onClick={() => {
                      this.setState({
                        courseCode: "",
                        courseCodeError: "",
                      });
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                </>}
              </div>

              <ChipInput
                fullWidth
                disabled={this.props.selRole === "ta" || this.props.adminView}
                margin="normal"
                label="Co-Instructors"
                placeholder="coInstructor@ucsd.edu"
                value={this.state.coInstructors}
                helperText="enter the email address associated with co-instructor account"
                onAdd={(coInstructor) => {
                  coInstructor = coInstructor.trim();
                  this.setState((prevState) => ({
                    coInstructors: [...prevState.coInstructors, coInstructor],
                  }));
                }}
                onDelete={(deletedCoInstructor, index) => {
                  this.setState((prevState) => ({
                    coInstructors: prevState.coInstructors.filter(
                      (coInstructor) => coInstructor !== deletedCoInstructor
                    ),
                  }));
                }}
              />
              <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.coInstructorEnableScreenshots}
                        color="primary"
                        onChange={(event) => {
                          this.setState({
                            coInstructorEnableScreenshots: event.target.checked,
                          });
                        }}
                        name="coInstructorEnableScreenshots"
                        
                      />
                    }
                    disabled={this.props.adminView || this.props.selRole === "ta" /*|| this.state.coInstructors.includes(this.props.account.accountEmail)*/}
                    label={<Typography>Allow co-instructors to take screenshots if feature enabled</Typography>}
                    style={{ marginLeft: 12, marginTop: 12 }}
              />
              <ChipInput
                disabled={this.props.selRole === "ta" || this.props.adminView}
                fullWidth 
                error={this.state.taError}
                margin="normal"
                label="TAs"
                placeholder="ta@ucsd.edu"
                value={this.state.tas}
                helperText={this.state.taError ? "you can only have " + this.state.maxTAs + " ta(s)" : "enter the email address associated with ta account"}
                onAdd={(ta) => {

                  if (this.state.tas.length >= this.state.maxTAs) {
                    this.setState({
                      taError: true,
                    });
                  } else {
                    ta = ta.trim();
                    this.setState((prevState) => ({
                      tas: [...prevState.tas, ta],
                      taError: false,
                    }));
                  }
                }}
                onDelete={(deletedTA, index) => {
                  this.setState((prevState) => ({
                    tas: prevState.tas.filter(
                      (ta) => ta !== deletedTA
                    ),
                    taError: this.state.tas.length > this.state.maxTAs ? true : false,
                  }));
                }}
              />
              {this.state.tas.length !== 0 && 
              <FormControl size="small" fullWidth style={{ marginTop: 20, marginBottom: 10 }}>
                <InputLabel id="ta-priv-label">TA Privileges</InputLabel>
                  <Select
                    labelId="ta-priv-label"
                    id="ta-priv"
                    multiple
                    disabled={this.props.selRole === "ta" || this.props.adminView}
                    value={this.state.taPrivileges}
                    sx={{'& .MuiSelect-select': {paddingLeft: "14px"}}}
                    input={<OutlinedInput label="TA Privileges" />}
                    onChange={(event) => {
                      let selPrivileges = event.target.value;

                      if (selPrivileges.includes("Edit Enrollment") && !selPrivileges.includes("View Enrollment")) {

                        if (this.state.taPrivileges.includes("View Enrollment")) {
                          selPrivileges.splice(selPrivileges.indexOf("Edit Enrollment"), 1);
                        } else {
                          selPrivileges.push("View Enrollment");
                        }
                      }

                      if (selPrivileges.includes("Delete Sessions") && !selPrivileges.includes("Delete Polls")) {

                        if (this.state.taPrivileges.includes("Delete Polls")) {
                          selPrivileges.splice(selPrivileges.indexOf("Delete Sessions"), 1);
                        } else {
                          selPrivileges.push("Delete Polls");
                        }
                      }

                      selPrivileges.sort();
                      this.setState({
                        taPrivileges: selPrivileges,
                      });
                    }}
                    // label="TA Privileges"
                    renderValue={(selected) => selected.join(', ')}
                    // renderValue={(selected) => (
                    //   <div >
                    //     {selected.map((value) => (
                    //       <Chip key={value} label={value}  />
                    //     ))}
                    //   </div>
                    // )}
                    // MenuProps={MenuProps} 
                  >
                  {privileges.map((privilege) => (
                    <MenuItem 
                      key={privilege} 
                      value={privilege} 
                      style={{display: !this.state.lockedPolls && privilege === "Open Lockout Polls" ? "none" : "flex"}}
                    >
                      <Checkbox checked={this.state.taPrivileges.includes(privilege)} />
                      <ListItemText primary={privilege} />
                    </MenuItem>
                  ))}
                  </Select>
              </FormControl>}
              {/* <ChipInput
                fullWidth
                margin="normal"
                label="Tutors"
                placeholder="tutor@ucsd.edu"
                value={this.state.tutors}
                helperText="enter the email address associated with tutor account"
                onAdd={(tutors) => {
                  this.setState((prevState) => ({
                    tutors: [...prevState.tutors, tutors],
                  }));
                }}
                onDelete={(deletedTutors, index) => {
                  this.setState((prevState) => ({
                    tutors: prevState.tutors.filter(
                      (tutor) => tutor !== deletedTutors
                    ),
                  }));
                }}
              /> */}

              <ChipInput
                fullWidth
                disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Categories"))}
                margin="normal"
                label="Categories"
                placeholder=""
                value={this.state.categoryNames}
                helperText={
                  this.props.course === undefined ||
                  Object.keys(this.props.course.courseCategories).filter(
                    (value) => !this.state.categoryNames.includes(value)
                  ).length === 0
                    ? ""
                    : "Warning: Deleted categories cannot be recovered!"
                }
                onAdd={(categoryName) => {
                  let newCategoryNames = this.state.categoryNames;
                  let newOptionNames = this.state.optionNames;
                  let newOptionNamesErrors = this.state.optionNamesErrors;
                  newCategoryNames.push(categoryName);

                  if (
                    this.props.course !== undefined &&
                    this.props.course.courseCategories[categoryName] !==
                      undefined
                  ) {
                    newOptionNames.push(
                      this.props.course.courseCategories[categoryName].slice()
                    );
                  } else {
                    newOptionNames.push([]);
                  }
                  newOptionNamesErrors.push("");

                  this.setState({
                    categoryNames: newCategoryNames,
                    optionNames: newOptionNames,
                    optionsErrors: newOptionNamesErrors,
                  });
                }}
                onDelete={(categoryName, categoryIndex) => {
                  let newCategoryNames = this.state.categoryNames;
                  let newOptionNames = this.state.optionNames;
                  let newOptionNamesErrors = this.state.optionNamesErrors;
                  newCategoryNames.splice(categoryIndex, 1);
                  newOptionNames.splice(categoryIndex, 1);
                  newOptionNamesErrors.splice(categoryIndex, 1);

                  this.setState({
                    categoryNames: newCategoryNames,
                    optionNames: newOptionNames,
                    optionsErrors: newOptionNamesErrors,
                  });
                }}
              />

              {this.state.categoryNames.map((categoryName, categoryIndex) => (
                <ChipInput
                  key={categoryName}
                  disabled={this.props.adminView || (this.props.selRole === "ta" && !this.state.taPrivileges.includes("Edit Categories"))}
                  fullWidth
                  margin="normal"
                  label={categoryName}
                  placeholder=""
                  value={this.state.optionNames[categoryIndex]}
                  error={
                    this.state.optionNamesErrors[categoryIndex].length !== 0
                  }
                  helperText={
                    this.state.optionNamesErrors[categoryIndex].length !== 0
                      ? this.state.optionNamesErrors[categoryIndex]
                      : this.props.course === undefined ||
                        this.props.course.courseCategories[categoryName] ===
                          undefined ||
                        this.props.course.courseCategories[categoryName].filter(
                          (value) =>
                            !this.state.optionNames[categoryIndex].includes(
                              value
                            )
                        ).length === 0
                      ? ""
                      : "Warning: Deleting this category's options will reset the student options for this category!"
                  }
                  onAdd={(optionName) => {
                    let newOptionNames = this.state.optionNames;
                    let newOptionNamesErrors = this.state.optionNamesErrors;
                    newOptionNames[categoryIndex].push(optionName);
                    newOptionNamesErrors[categoryIndex] = "";

                    this.setState({
                      optionNames: newOptionNames,
                      optionNamesErrors: newOptionNamesErrors,
                    });
                  }}
                  onDelete={(optionName, optionIndex) => {
                    let newOptionNames = this.state.optionNames;
                    let newOptionNamesErrors = this.state.optionNamesErrors;
                    newOptionNames[categoryIndex].splice(optionIndex, 1);
                    newOptionNamesErrors[optionIndex] = "";

                    this.setState({
                      optionNames: newOptionNames,
                      optionNamesErrors: newOptionNamesErrors,
                    });
                  }}
                />
              ))}
            </>
          )}
          {(this.state.tab === 2) && (
            <div className={this.props.classes.toggles}>
              <TableContainer sx={{  marginTop: "25px", marginBottom: "25px" }} component={Paper}>
                <Table aria-label="usage-summary">
                  <TableHead >
                    <TableRow>
                      <TableCell sx={{fontWeight: "bold"}}>Usage Summary</TableCell>
                      <TableCell align="right">
                        <IconButton
                          color={this.state.starred ? "primary" : "default"}
                          onClick={() => {
                            this.setState({starred: !this.state.starred});
                          }}
                        >
                          <StarIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell>Metric</TableCell>
                      <TableCell align="right">Value</TableCell>
                    </TableRow> */}
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Created On</TableCell>
                      <TableCell align="right">{this.props.course.courseCreated ? convertUnixToDate(this.props.course.courseCreated) : "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Total Students</TableCell>
                      <TableCell align="right">{this.props.course.totStudents}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Total TAs</TableCell>
                      <TableCell align="right">{this.props.course.tas.length}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Total Sessions</TableCell>
                      <TableCell align="right">{this.props.course.totSessions}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Total Polls</TableCell>
                      <TableCell align="right">{this.props.course.totPolls}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Last Poll</TableCell>
                      <TableCell align="right">{this.props.course.lastPoll ? convertUnixToDate(this.props.course.lastPoll) : "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Marked for Archiving</TableCell>
                      <TableCell align="right">{!!this.state.markedForArchive ? convertUnixToDate(this.state.markedForArchive) : "N/A"}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <TextField
                fullWidth
                margin="normal"
                label="Max Number of TAs"
                value={this.state.maxTAs}
                onChange={(event) => {

                  if (!isNaN(+event.target.value) || event.target.value === "") {
                    this.setState({maxTAs: event.target.value});
                  }
                }}
              />

            </div>
          )}
        </DialogContent>
        <InstructorCourseSettingsDialogs
          markedForArchiveDialog={this.state.markedForArchive}
          studentCategoriesDialog={this.state.studentCategoriesDialog}
          // forcePIDDialog={this.state.forcePIDDialog}
          restrictDomainDialog={this.state.restrictDomainDialog}
          anonVotingDialog={this.state.anonVotingDialog}
          geofencingDialog={this.state.geofencingDialog}
          pollHistoryDialog={this.state.pollHistoryDialog}
          screenshotDialog={this.state.screenshotDialog}
          archiveCourseDialog={this.state.archiveCourseDialog}
          closeStudentCategoriesDialog={() =>
            this.setState({ studentCategoriesDialog: false })
          }
          // closeForcePIDDialog={() =>
          //   this.setState({ forcePIDDialog: false })
          // }
          closeRestrictDomainDialog={() => {
            this.setState({ restrictDomainDialog: false });
          }}
          closeAnonVotingDialog={() =>
            this.setState({ anonVotingDialog: false })
          }
          closeGeofencingDialog={() =>
            this.setState({ geofencingDialog: false })
          }
          closePollHistoryDialog={() =>
            this.setState({ pollHistoryDialog: false })
          }
          closeScreenshotDialog={() =>
            this.setState({ screenshotDialog: false })
          }
          closeArchiveCourseDialog={() => 
            this.setState({ archiveCourseDialog: false})
          }
        />
        <DialogActions>
          {this.props.selRole === "ta" && 
          !this.state.taPrivileges.includes("Change Course Code") &&
          !this.state.taPrivileges.includes("Edit Course Options") && 
          !this.state.taPrivileges.includes("Add Categories") &&
          !this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")
          ? 
            <Button
              color="primary"
              onClick={() => {
                this.props.openCtl(false);
              }}
            >
              Close
            </Button>
          : <>
            <Button
              color="primary"
              onClick={() => {
                this.props.openCtl(false);
              }}
            >
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={async () => {
                let error = false;
                this.setState({ loading: true });

                if (this.props.adminView) {
                  let adminData = {
                    courseID: this.state.courseID,
                    starred: this.state.starred,
                    maxTAs: this.state.maxTAs,
                    markedForArchive: this.state.markedForArchive,
                    isActive: this.state.isActive,
                    notifyArchive: this.state.notifyArchive || (this.props.course.isActive && !this.state.isActive),
                  };
                  await updateCourseAdminSettings(adminData);
                  this.setState({ loading: false });
                  this.props.openCtl(false);
                  this.props.updateCourse(adminData);
                  return;
                }
                // The course name cannot be empty
                if (this.state.name.length === 0) {
                  this.setState({ nameError: "Please specify a course name." });
                  error = true;
                }

                // The term cannot be empty
                if (this.state.term.length === 0) {
                  this.setState({
                    termError: "Please specify a term (eg. Fall 2020).",
                  });
                  error = true;
                }

                // The category options cannot be empty
                let newOptionNamesErrors = this.state.optionNamesErrors;
                this.state.optionNames.forEach((optionNames, optionIndex) => {
                  if (optionNames.length === 0) {
                    newOptionNamesErrors[optionIndex] =
                      "Please specify at least one option for this category.";
                    error = true;
                  }
                });

                this.setState({ optionNamesErrors: newOptionNamesErrors });

                if (!error) {
                  let courseCategories = {};
                  let modifiedCategories = []; // Contains all categories that were deleted or had removed options

                  this.state.categoryNames.forEach(
                    (categoryName, categoryIndex) => {
                      courseCategories[categoryName] =
                        this.state.optionNames[categoryIndex];

                      // Add all categories with removed options to modifiedCategories
                      if (
                        this.props.course !== undefined &&
                        this.props.course.courseCategories[categoryName] !==
                          undefined &&
                        this.props.course.courseCategories[categoryName].filter(
                          (value) =>
                            !this.state.optionNames[categoryIndex].includes(value)
                        ).length !== 0
                      ) {
                        modifiedCategories.push(categoryName);
                      }
                    }
                  );

                  // Add all categories that were deleted to modifiedCategories
                  modifiedCategories = modifiedCategories.concat(
                    this.props.course === undefined
                      ? []
                      : Object.keys(this.props.course.courseCategories).filter(
                          (value) => !this.state.categoryNames.includes(value)
                        )
                  );

                  // If screenshotDevice is checked, record the device into the database
                  // let deviceUUID = localStorage.getItem("deviceUUID");
                  // let correctDevice = false;
                  // Co-Instuctor has screenshot functionality disabled
                  // if (
                  //   this.state.coInstructors.includes(
                  //     this.props.account.accountID
                  //   )
                  // ) {
                  //   deviceUUID = this.props.course.screenshotDevice;
                  // } else if (this.state.screenshotDevice) {
                  //   if (
                  //     deviceUUID != null &&
                  //     deviceUUID == this.props.course.screenshotDevice
                  //   ) {
                  //     deviceUUID = this.props.course.screenshotDevice;
                  //     correctDevice = true;
                  //   } else {
                  //     deviceUUID = uuidv4();
                  //     localStorage.setItem("deviceUUID", deviceUUID);
                  //     correctDevice = true;
                  //   }
                  // } else {
                  //   if (this.props?.course?.screenshotDevice == deviceUUID) {
                  //     deviceUUID = null;
                  //   } else if (this.props?.course?.screenshotDevice) {
                  //     deviceUUID = this.props.course.screenshotDevice;
                  //   } else {
                  //     deviceUUID = null;
                  //   }
                  // }


                  // If screenshot enabled and correct device set state
                  // Co-Instuctor has screenshot functionality disabled
                  // if (
                  //   this.state.screenshotsEn &&
                  //   correctDevice &&
                  //   !this.state.coInstructors.includes(
                  //     this.props.account.accountID
                  //   )
                  // ) {
                  //   this.props.setScreenshotEnabledDevice(true);
                  // } else {
                  //   this.props.setScreenshotEnabledDevice(false);
                  // }



                  // if (this.state.selectedDevice === this.state.currDeviceUUID) {
                  //   this.props.setScreenshotEnabledDevice(true);
                  // } else {
                  //   this.props.setScreenshotEnabledDevice(false);
                  // }

                  // // Initalize Google Drive if screenshots are now enabled
                  // // Co-Instuctor has screenshot functionality disabled
                  // if (
                  //   this.state.screenshotsEn /*&&
                  //   !this.state.coInstructors.includes(
                  //     this.props.account.accountID
                  //   ) &&
                  //   this.state.selectedDevice === this.state.currDeviceUUID*/
                  // ) {
                  //   await this.props.initGoogleDrive(this.state.courseID);
                  // }

                  // let courseFolderID = "";
                  // // Edit google drive folders
                  // // Co-Instuctor has screenshot functionality disabled
                  // if (
                  //   this.state.screenshotsEn /*&&
                  //   !this.state.coInstructors.includes(
                  //     this.props.account.accountID
                  //   ) &&
                  //   this.state.selectedDevice === this.state.currDeviceUUID*/
                  // ) {
                  //   let webclickerFolderName = "Webclicker";
                  //   let currentCourseFolderName = this.props.course.courseName;
                  //   let newCourseFolderName = this.state.name;

                  //   // Check and create Webclicker folder
                  //   let webclickerFolderID = await findDriveFolder(
                  //     webclickerFolderName
                  //   );
                  //   if (webclickerFolderID == null) {
                  //     webclickerFolderID = await createDriveFolder(
                  //       webclickerFolderName
                  //     );
                  //   }

                  //   // Check, update, and create course folder
                  //   courseFolderID = await findDriveFolder(
                  //     currentCourseFolderName,
                  //     webclickerFolderID
                  //   );
                  //   if (
                  //     courseFolderID != null &&
                  //     this.props?.course?.courseName !== this.state.name
                  //   ) {
                  //     courseFolderID = await changeDriveFolder(
                  //       courseFolderID,
                  //       newCourseFolderName
                  //     );
                  //   } else if (courseFolderID == null) {
                  //     courseFolderID = await createDriveFolder(
                  //       newCourseFolderName,
                  //       webclickerFolderID
                  //     );
                  //   }

                  //   if (this.props.course?.courseInstructorID !== this.props.account.accountID) {
                  //     await shareFolder(
                  //         courseFolderID,
                  //         this.props.course?.courseInstructorID,
                  //       );
                  //   }

                  //   if (this.state.coInstructorEnableScreenshots) {
                  //     for (const coInstructor of this.state.coInstructors) {
                  //       await shareFolder(
                  //         courseFolderID,
                  //         coInstructor,
                  //       );
                  //     }
                  //   }

                  //   if (this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) {
                  //     for (const ta of this.state.tas) {
                  //       await shareFolder(
                  //         courseFolderID,
                  //         ta,
                  //       );
                  //     }
                  //   }
                  // }

                  let data = {
                    courseID: this.state.courseID,
                    courseName: this.state.name,
                    courseTerm: this.state.term,
                    courseCode: this.state.courseCode,
                    courseCategories: courseCategories,
                    modifiedCategories: modifiedCategories,
                    courseInstructorID: this.state.courseInstructorID,
                    courseActivitySessionID: "",
                    courseActivityPollID: "",
                    isActive: this.state.isActive,
                    iClickerEn: this.state.iClickerEn,
                    iClickerFreq: this.state.iClickerFreq,
                    anonVoteEn: this.state.anonVoteEn,
                    anonChooseCategories: this.state.anonChooseCategories,
                    // forcePID: this.state.forcePID,
                    restrictDomain: this.state.restrictDomain,
                    restrictDomainEmail: this.state.restrictDomainEmail,
                    restrictDomainOverride: this.state.restrictDomainOverride,
                    geofencing: this.state.geofencing,
                    geoDistance: this.state.geoDistance,
                    screenshotsEn: this.state.screenshotsEn,
                    screenshotDevice: this.state.selectedDevice,
                    // screenshotDevice: deviceUUID,
                    coInstructors: this.state.coInstructors,
                    coInstructorEnableScreenshots: this.state.coInstructorEnableScreenshots,
                    tas: this.state.tas,
                    taPrivileges: this.state.taPrivileges,
                    // tutors: this.state.tutors,
                    studentPollHistory: this.state.studentPollHistory,
                    chooseCategories: this.state.chooseCategories,
                    docLink: this.state.docLink,
                    includedSessions: this.state.includedSessions,
                    googleDriveFolderID: this.props.course?.googleDriveFolderID ?? "",
                    lockedPolls: this.state.lockedPolls,
                    anonymousCourse: this.state.anonymousCourse,
                    notifyArchive: (this.props.course?.isActive && !this.state.isActive) ? false : this.state.notifyArchive || (!this.props.course?.isActive && this.state.isActive && this.state.markedForArchive),
                    // deviceOptions: this.state.deviceOptions,
                  };

                  createCourse(data).then(async (courseID) => {
                    const removedTAs = this.props.course?.tas ? this.props.course.tas.filter((ta) => !this.state.tas.includes(ta)) : [];
                    
                    if (removedTAs.length > 0) {
                      await checkRemovedTAs({ accounts: removedTAs });
                    }

                    if (!this.state.isActive && this.props.course?.isActive) {
                      await checkRemovedTAs({ accounts: this.state.tas });
                    } else if (this.state.isActive && !this.props.course?.isActive && this.state.tas.length > 0) {
                      await convertToTAType({ accounts: this.state.tas });
                    } else if (this.state.isActive) {
                      const newTAs = this.state.tas.filter((ta) => !this.props.course?.tas?.includes(ta));
                      
                      if (newTAs.length > 0) {
                        await convertToTAType({ accounts: newTAs });
                      }
                    }
                    
                    if (this.state.selectedDevice[this.props.account.accountEmail] === this.state.currDeviceUUID) {
                      this.props.setScreenshotEnabledDevice(true);
                    } else {
                      this.props.setScreenshotEnabledDevice(false);
                    }

                    // Initalize Google Drive if screenshots are now enabled
                    // Co-Instuctor has screenshot functionality disabled
                    if (
                      this.state.screenshotsEn /*&&
                      !this.state.coInstructors.includes(
                        this.props.account.accountID
                      ) &&
                      this.state.selectedDevice === this.state.currDeviceUUID*/
                    ) {
                      let data = {
                        courseID: courseID,
                        user: this.props.account.accountEmail
                      }
                      await this.props.initGoogleDrive(data);
                    }

                    let courseFolderID = "";
                    // Edit google drive folders
                    // Co-Instuctor has screenshot functionality disabled
                    if (
                      this.state.screenshotsEn/*&&
                      !this.state.coInstructors.includes(
                        this.props.account.accountID
                      ) &&
                      this.state.selectedDevice === this.state.currDeviceUUID*/
                    ) {
                      let webclickerFolderName = "Webclicker";
                      let currentCourseFolderName = this.props.course?.courseName + "_" + this.props.course?.courseTerm;
                      let newCourseFolderName = this.state.name + "_" + this.state.term;
                      let updateCourseFolder = false;

                      // Check and create Webclicker folder
                      let webclickerFolderID = await findDriveFolder(
                        webclickerFolderName
                      );
                      if (webclickerFolderID == null) {
                        webclickerFolderID = await createDriveFolder(
                          webclickerFolderName
                        );
                      }

                      // Check, update, and create course folder
                      courseFolderID = await findDriveFolder(
                        currentCourseFolderName,
                        webclickerFolderID
                      );
                      
                      if (
                        courseFolderID != null &&
                        currentCourseFolderName !== newCourseFolderName
                      ) {
                        courseFolderID = await changeDriveFolder(
                          courseFolderID,
                          newCourseFolderName
                        );
                      } else if (courseFolderID == null) {
                        courseFolderID = await createDriveFolder(
                          newCourseFolderName,
                          webclickerFolderID
                        );
                        updateCourseFolder = true;
                      }

                      if (courseFolderID !== null) {

                        let sharedDriveUsers = [];

                        if (!this.props.course?.screenshotsEn && this.state.courseInstructorID !== this.props.account.accountID) {
                          sharedDriveUsers.push(this.state.courseInstructorID);
                          // await shareFolder(
                          //     courseFolderID,
                          //     this.props.course?.courseInstructorID,
                          //   );
                        }

                        // let newlyAdded = [];
                        if (this.state.coInstructorEnableScreenshots) {
                          sharedDriveUsers = sharedDriveUsers.concat(this.state.coInstructors);
                          // for (const coInstructor of this.state.coInstructors) {
                          //   await shareFolder(
                          //     courseFolderID,
                          //     coInstructor,
                          //   );
                          // }
                          // newlyAdded = newlyAdded.concat(this.state.coInstructors.filter((coInstructor) => !this.props.course?.coInstructors.includes(coInstructor)));
                        }

                        if (this.state.taPrivileges.includes("Take Screenshots if Feature Enabled")) {
                          sharedDriveUsers = sharedDriveUsers.concat(this.state.tas);
                          // newlyAdded = newlyAdded.concat(this.state.tas.filter((ta) => !this.props.course?.tas?.includes(ta)));
                          // for (const ta of this.state.tas) {
                          //   await shareFolder(
                          //     courseFolderID,
                          //     ta,
                          //   );
                          // }
                        }

                        if (sharedDriveUsers.length > 0) {
                          let sharingData = {
                            sharedDriveUsers: sharedDriveUsers,
                            courseFolderID: courseFolderID,
                          };
                          await shareFolder(sharingData);
                        }
                        // for (const newUser of newlyAdded) {
                        //   await shareFolder(
                        //     courseFolderID,
                        //     newUser,
                        //   );
                        // }

                        if (updateCourseFolder) {
                          let folderData = {
                            folderOwner: this.props.account.accountEmail,
                            courseID: courseID,
                            googleDriveFolderID: courseFolderID,
                          };
                          await addCourseDriveFolder(folderData);
                        }
                      }

                      let devicesData = {
                        email: this.props.account.accountEmail,
                        screenshotDevices: this.state.deviceOptions,
                      };
                      await setScreenshotDevices(devicesData);
                    }
                    return courseID;
                  }).then(async(courseID) => {

                    if (!this.props.course?.anonymousCourse && this.state.anonymousCourse) {
                      this.props.openAnonCourseDialog(true);
                    } else {

                      if (this.props.course?.anonymousCourse && !this.state.anonymousCourse) {
                        await reenrollStudents({courseID: courseID});
                      }
                      this.refreshCourses();
                    }
                    
                  }).catch((error) => {
                    console.log(error);
                  });
                } else {
                  this.setState({ loading: false });
                }
              }}
            >
              Save
            </Button>
          </>}
        </DialogActions>
        {this.state.loading && <LinearProgress />}
      </Dialog>
      <Dialog
        open={this.props.anonCourseDialog ?? false}
      >
        <DialogTitle>
            <Typography style={{ fontSize: "1.3rem" }} color="primary">
              Apply changes to currently enrolled students?
            </Typography>
        </DialogTitle>

        <DialogContent>
            <Typography>
              You have chosen to restrict enrollment in {this.state.name} to anonymous users only, but there are currently logged-in students enrolled in this course. These students will still be able to access the course while logged in. Do you wish to instead prevent them from accessing the course while logged in? Any existing data related to these students will be preserved, but going forward, they will only be able to access the course as anonymous users.
            </Typography>
        </DialogContent>
        <DialogActions
            style={{display: "flex", flexDirection: "row", justifyContent: "center"}}
        >
            <Button 
              color="primary" 
              onClick={() => {
                clearStudentRoster({courseID: this.state.courseID}).then(() => {
                  this.refreshCourses().then(() => {
                    this.props.openAnonCourseDialog(false);
                  });
                });
              }}
            >
              Yes
            </Button>
            <Button 
              color="primary" 
              onClick={() => {
                this.refreshCourses().then(() => {
                  this.props.openAnonCourseDialog(false);
                });
              }}
            >
              No
            </Button>
        </DialogActions>
      </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCourses: (data) => dispatch(changeCourses(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(InstructorCourseSettings)
    )
  )
);
